import { Modal } from "@mui/material";
import React, { useEffect } from "react";
import Styles from "./OnboardingPopup.module.css";
import RegisterComponent from "../../../Auth/Register/RegisterComponent";
import CloseIcon from "@mui/icons-material/Close";

const OnboardingPopup = ({ open, handleClose }) => {
  const handleCloseModal = (reason = "manual") => {
    handleClose();
  };

  const handleRegistrationComplete = () => {
    handleCloseModal("registration-complete");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {}}
        aria-labelledby="onboarding-modal-title"
        aria-describedby="onboarding-modal-description"
        className={Styles.registerPopup}
        disableEscapeKeyDown={true}
        disableAutoFocus={false}
        disableEnforceFocus={false}
        disableRestoreFocus={false}
        BackdropProps={{
          style: { pointerEvents: "none" },
        }}
      >
        <div
          className={Styles.modalContentWrapper}
          style={{
            pointerEvents: "auto",
            zIndex: 10000,
          }}
        >
          <div
            className={Styles.modalCloseButton}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleCloseModal("close-icon");
            }}
          >
            <CloseIcon style={{ fontSize: "18px", cursor: "pointer" }} />
          </div>
          <div
            className={Styles.registerComponentWrapper}
            style={{
              pointerEvents: "auto",
              zIndex: 10000,
              position: "relative",
            }}
          >
            <RegisterComponent
              disableNavigation={true}
              onComplete={handleRegistrationComplete}
              isOnboardingMode={true}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default OnboardingPopup;
